
  <!---------- Stepper Form ------------------------------- -->
  <div class="row">
    <div class="col-sm-12">
        <div class="content-header">Lead Form</div>
    </div>
  </div>
  <section id="ngx">
    <div class="card">
        <div class="card-content">
            <div class="card-body">
  
                <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
                    <aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
                        <form>
                            <h4 class="head text-center">Contact Info</h4>
                            <br/>
                            <div class='row'>
                                <div class='col-12'>
                                    <div class="row">
                                        <div class='col-12 col-sm-6'>
                                            <div class="form-group">
                                                <label class="form-control-label" for="name">Name<span class="required_field">*</span></label>
                                                <input class="form-control input-md" ngModel #name="ngModel" [(ngModel)]="leadModel.name"  [ngModelOptions]="{standalone: true}"  required id="name" name="name" type="text" placeholder="Enter name" required>
                                                <small class="form-text text-muted danger" *ngIf="!allLetter(name) && (name.dirty || name.touched)">Please enter valid name!</small>

                                            </div>
                                        </div>
                                        <!-- <div class='col-12 col-sm-6' *ngIf="!leadId">
                                          <label class="form-control-label" for="address">Landmark</label>
                                          <input class="form-control input-md" [(ngModel)]="leadModel.address" [ngModelOptions]="{standalone: true}"
                                          (keydown.enter)="$event.preventDefault()" autocorrect="off"
                                          autocapitalize="off" spellcheck="off"  address id="address" name="address" type="text" placeholder="Enter location" #search>
                                        </div> -->
                                        <div class='col-12 col-sm-6'>
                                          <label class="form-control-label" for="address">Landmark</label>
                                          <input class="form-control input-md" [(ngModel)]="leadModel.landmark.address" [ngModelOptions]="{standalone: true}"
                                          address id="address" name="address" type="text" placeholder="Enter location" #search>
                                        </div>
                                    </div>
                                    <div class="row">
                                      <div class='col-12 col-sm-6'>
                                        <label class="form-control-label" for="email">Email</label>
                                        <input class="form-control input-md" ngModel #email="ngModel" [(ngModel)]="leadModel.email" [ngModelOptions]="{standalone: true}" id="email" name="email" type="text" placeholder="Enter email">
                                        <small class="form-text text-muted danger" *ngIf="ValidateEmail(leadModel.email) && (email.dirty || email.touched)">Please enter a valid email!</small>
                                      </div>
                                      <div class='col-12 col-sm-6'>
                                        <div class="form-group">
                                            <label class="form-control-label" for="location">Location</label>
                                            <input class="form-control input-md" ngModel #location="ngModel" [(ngModel)]="leadModel.location" [ngModelOptions]="{standalone: true}" required name="location" type="text" placeholder="Enter location">
                                            <!-- <small class="form-text text-muted danger" *ngIf="!landmark.valid && (landmark.dirty || landmark.touched)">This field is required!</small> -->
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class='col-12 col-sm-6'>
                                        <label class="form-control-label" for="phone">Phone</label>
                                        <input class="form-control input-md" [(ngModel)]="leadModel.phone"   phone id="phone" name="phone" [formControl]="phoneControl"
                                        type="text"  placeholder="e.g. 1234-567-890" mask="0000-000-000" minlength="10">
                                        <small *ngIf="isPhoneExists !==''" class="form-text text-muted danger">{{isPhoneExists}}</small>
                                      </div>
                                     
                                      <div class='col-12 col-sm-6'>
                                        <div class="form-group">
                                            <label class="form-control-label" for="lastname">SOCIAL MEDIA</label>
                                            <fieldset class="position-relative has-icon-right">
                                              <ng-select [items]="socailmediaList" bindLabel="displayname" bindValue="_id" placeholder="Select social media"
                                              [(ngModel)]="leadModel.socialmedia" [ngModelOptions]="{standalone: true}" (change)="getChangeSocialMedia($event)">
                                              </ng-select>
                                            </fieldset> 
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="form-group text-center mt-2">
                                        <button [disabled]="!name.valid"  (click)="leadModel.title = leadModel.title?leadModel.title:'Lead for '+leadModel.name" type="button" uiSref="work" class="btn btn-info"  awNextStep>
                                            Next
                                            <span style="margin-left:10px;">
                                                <i class="ft-chevron-right"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </aw-wizard-step>
                
                    <aw-wizard-step [stepTitle]="'Step 2'" [navigationSymbol]="{ symbol: '&#xf0ac;', fontFamily: 'FontAwesome' }">
                      
                      <form >
                        <h4 class="head text-center">Lead Info</h4>
                        <br/>
                        <div class='row'>
                            <div class='col-12'>
                                <div class="row">
                                    <div class='col-12 col-sm-6'>
                                        <div class="form-group">
                                            <label class="form-control-label" for="title">Title</label>
                                            <input class="form-control input-md" ngModel #title="ngModel" [(ngModel)]="leadModel.title" [ngModelOptions]="{standalone: true}"  id="title" name="title" type="text" placeholder="Enter title">
                                            <!-- <small class="form-text text-muted danger" *ngIf="!title.valid && (title.dirty || title.touched)">title is required!</small> -->
                                        </div>
                                    </div>
                                    <div class='col-12 col-sm-6'>
                                      <label>Source<span class="required_field">*</span></label>
                                      <ng-select
                                        [items]="sourceList"
                                        bindLabel="displayname"
                                        bindValue="_id"
                                        placeholder="Select Source"
                                        [(ngModel)]="leadModel.source"
                                        [ngModelOptions]="{ standalone: true }"
                                        (change)="getSourceId($event)"
                                        >
                                      </ng-select>
                                    </div>

                                    <div class='col-12 col-sm-6'>
                                      <div class="form-group">
                                        <label for="lastresponse">Last Response</label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          [(ngModel)]="leadModel.lastresponse" [ngModelOptions]="{standalone: true}"
                                          id="lastresponse"
                                          placeholder="Enter last response"
                                        />
                                      </div>
                                    </div>
                                    <div class='col-12 col-sm-6'>
                                      <label class="form-control-label mb-1" for="college">Next Action</label>
                                      <fieldset class="position-relative has-icon-right">
                                        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
                                          [(ngModel)]="leadModel.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
                                        </ng-select>
                                      </fieldset>
                                    </div>
                                
                                </div>
                                <div class="row">
                                  <div class='col-12 col-sm-6'>
                                    <label for="last_activedate">Last Active Date</label>
                                    <input
                                      type="date"
                                      class="form-control"
                                      [(ngModel)]="this.leadModel.last_activedate" [ngModel]="this.leadModel.last_activedate | date: 'yyyy-MM-dd'" [ngModelOptions]="{standalone: true}" [disabled]="false"
                                      id="last_activedate"
                                      placeholder="Enter last active date"
                                    />
                                  </div>
                                  <div class='col-12 col-sm-6'>
                                    <label class="form-control-label" for="notes">Lead Notes</label>
                                    <textarea class="form-control input-md" ngModel [(ngModel)]="leadModel.notes" [ngModelOptions]="{standalone: true}"
                                      #notes="ngModel" name="notes" id="notes" cols="30" rows="1" placeholder="Enter notes"></textarea>
                                  </div>
                                  <!-- <div class='col-12 col-sm-6'>
                                    <label class="form-control-label" for="notes">leadModel Admin Notes</label>
                                    <textarea class="form-control input-md" ngModel [(ngModel)]="leadModel.admin_notes" [ngModelOptions]="{standalone: true}"
                                      #notes="ngModel" name="notes" id="notes" cols="30" rows="1" placeholder="Enter admin notes"></textarea>
                                  </div> -->
                                </div>
                                <div class="form-group text-center mt-2">
                                  <button
                                    uiSref="work"
                                    type="button"
                                    class="btn btn-secondary mr-1"
                                    awPreviousStep
                                  >
                                    <span style="margin-right: 10px">
                                      <i class="ft-chevron-left"></i>
                                    </span>
                                    Previous
                                  </button>
                                
                                  <button [disabled]="!leadModel.source" type="button" uiSref="work" class="btn btn-info"  awNextStep>
                                    Next
                                    <span style="margin-left:10px;">
                                        <i class="ft-chevron-right"></i>
                                    </span>
                                </button>
                                </div>
                                
                            </div>
                        </div>
                    </form>
                    </aw-wizard-step>
                    <aw-wizard-step  [stepTitle]="'Step 3'" [navigationSymbol]="{ symbol: '&#xf0b1;', fontFamily: 'FontAwesome' }">
                      <form>
                        <h4 class="head text-center">Training Info?</h4>
                        <br/>
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-12 col-md-6">
                                <div class="form-group">
                                  <label class="form-control-label" for="skills">Skills</label>
                                  <ng-select
                                    [items]="tagsList"
                                    bindLabel="displayname"
                                    bindValue="_id"
                                    #skills="ngModel"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    placeholder="Select Skill"
                                    [(ngModel)]="selectedSkill"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="getTagsId($event)">
                                <small
                                class="form-text text-muted danger"
                                *ngIf="
                                  !selectedTag
                                "
                                >Please fill at least one skill!</small
                              >
                                  </ng-select>
                                </div>
                              </div>
                              <div class='col-12 col-sm-6'>
                                <div class="form-group">
                                  <label>College</label>
                                  <ng-select
                                    [items]="collegeList"
                                    bindLabel="name"
                                    color="is_activated"
                                    bindValue="_id"
                                    placeholder="Select College"
                                    [(ngModel)]="leadModel.college_id"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="getCollegeId($event)"
                                    >
                                </ng-select>
                                </div>
                            </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-md-6">
                                <div class="form-group">
                                  <label class="form-control-label" for="interest">Category Interest</label>
                                  <ng-select
                                    [items]="categoryList"
                                    bindLabel="displayname"
                                    bindValue="_id"
                                    name="interest"
                                    placeholder="Select Course Interest"
                                    [(ngModel)]="leadModel.coursecatinterest_id"
                                    #interest="ngModel"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="getCategoryId($event)"> 
                                  </ng-select>
                                </div>
                              </div>
                              <div class="col-12 col-md-6">
                                <div class="form-group">
                                <label class="form-control-label" for="qualification">Qualification</label>
                                <input class="form-control input-md" ngModel #qualification="ngModel"  [(ngModel)]="leadModel.qualification" [ngModelOptions]="{standalone: true}" required qualification id="qualification" name="qualification" type="text" placeholder="Enter qualification">
                                <!-- <small class="form-text text-muted danger" *ngIf="!qualification.valid && (qualification.dirty || qualification.touched)">Please enter a valid qualification!</small> -->
                                </div>
                              </div>
                             
                            </div>
                          
                           
                            <div class="form-group text-center mt-2">
                              <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                                <span style="margin-right:10px;">
                                    <i class="ft-chevron-left"></i>
                                </span> Previous</button>
                                <button
                                uiSref="result"
                                type="button"
                                class="btn btn-success" (click)="leadSubmit()">
                                Finish
                                <span style="margin-left: 10px">
                                  <i class="ft-chevron-right"></i>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                    </form>
                     
                    </aw-wizard-step>
                </aw-wizard>
  
  
            </div>
        </div>
    </div>
  </section>


